import { MesosConfig } from "./config/mesos-config";

const disableBot = (
    mesosConfig: MesosConfig,
    host: string,
    pathName: string
): boolean => {
    let disable = false;

    if (mesosConfig.disableBotAllSites) {
        disable = true;
    } else {
        const urlWithoutProtocol = host + pathName;

        for (const disabledDomain of mesosConfig.disableBotOn) {
            // Some urls have a trailing slash for window.location.pathname, others don't
            // Someone might add a trailing slash in app.json for UI_DISABLE_BOT_ON
            // Both cases should be handled the same way

            const browserUrl =
                urlWithoutProtocol.endsWith("/")
                    ? urlWithoutProtocol.slice(0, urlWithoutProtocol.length - 1)
                    : urlWithoutProtocol;
            const mesosUrl =
                disabledDomain.endsWith("/")
                    ? disabledDomain.slice(0, disabledDomain.length - 1)
                    : disabledDomain;

            if (
                browserUrl ===
                mesosUrl.replace("https://", "").replace("http://", "")
            ) {
                disable = true;
                break;
            }
        }
    }
    return disable;
};

export default disableBot;
